module.exports = __webpack_public_path__ + "img/sw2-b4.b0fcbbf7.jpg";